export default __webpack_public_path__ + "static/media/ticTacToe.9684b500.bmp";